/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["a[_ngcontent-%COMP%]{color:#fff;text-decoration:none}.spacer[_ngcontent-%COMP%]{flex:1 1 auto}.right-links[_ngcontent-%COMP%]{padding-left:20px}"];
export { styles as styles };
